"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Application class
 * Manages application-level configuration.
 * 
 * Original author @heron-web/material (no longer maintained)
 */
class Application {
  /**
   * Called by `Navigator.navigate()` when navigation occurs.
   *
   * @type {Function<newUri: String, currentUri: String>|null}
   */
  static onNavigate = null;
}
var _default = exports.default = Application;